import type { LaneId } from "@fate-kingdom/engine";

import { perspectiveLaneX } from "../alpha/presentation/perspective-layout";

export type WorldTargetSide = "own" | "opponent";

export interface BattlefieldRowLayout {
  readonly opponentLandZ: number;
  readonly opponentFormationZ: number;
  readonly ownFormationZ: number;
  readonly ownLandZ: number;
  readonly rowSafeGap: number;
}

export const BATTLEFIELD_ROW_LAYOUT: BattlefieldRowLayout = Object.freeze({
  opponentLandZ: -3.65,
  opponentFormationZ: -1.3,
  ownFormationZ: 1.3,
  ownLandZ: 3.65,
  rowSafeGap: 0.28,
});

export const FIELD_CARD_SCALE = Object.freeze({
  land: 1.21,
  commander: 1.18,
  army: 0.99,
  crowdedArmy: 0.92,
});

export const WORLD_LAND_Y = 0.43;
export const WORLD_FORMATION_Y = 0.41;

export const WORLD_LAND_Z: Readonly<Record<WorldTargetSide, number>> = {
  own: BATTLEFIELD_ROW_LAYOUT.ownLandZ,
  opponent: BATTLEFIELD_ROW_LAYOUT.opponentLandZ,
};

export const WORLD_FORMATION_Z: Readonly<Record<WorldTargetSide, number>> = {
  own: BATTLEFIELD_ROW_LAYOUT.ownFormationZ,
  opponent: BATTLEFIELD_ROW_LAYOUT.opponentFormationZ,
};

export function worldTargetPosition(
  laneId: LaneId,
  side: WorldTargetSide,
  height = WORLD_LAND_Y,
  laneSpread = 2.55,
): readonly [number, number, number] {
  return [perspectiveLaneX(laneId, laneSpread), height, WORLD_LAND_Z[side]];
}
